import React, { useState } from "react";
import "../../css/Login.css";
import { forgotPassword } from "../../services/users/AuthService";
import { CircularProgress } from "@mui/material";
import Home from "@mui/icons-material/Home";

export default function RecoverPassword() {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const validateEmail = (value) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !regex.test(value)) {
            setEmailError("Email inválido");
        } else {
            setEmailError("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccessMessage("");
        validateEmail(email);

        if (!email || emailError) return;

        setLoading(true);
        try {
            const forgotPasswordRequest = { email };
            await forgotPassword(forgotPasswordRequest);
            setSuccessMessage(`Um email foi enviado para ${email} com instruções para recuperar a password.`);
        } catch (e) {
            setError(
                e.message 
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit} autoComplete="off">
                <h2 className="form-title">Recuperar Password</h2>
                <h3 className="form-title">Digite o seu email</h3>

                {error && <p className="form-error">{error}</p>}
                {successMessage && <p className="form-success">{successMessage}</p>}

                {loading && (
                    <div className="loading-container">
                        <CircularProgress size={40} style={{ color: "#04642c" }} />
                    </div>
                )}

                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onBlur={() => validateEmail(email)}
                    placeholder="Email"
                    disabled={loading}
                    required
                    autoComplete="off"
                />
                {emailError && <p className="form-error">{emailError}</p>}

                <button type="submit" disabled={loading}>
                    Enviar email
                </button>

                <div className="back-to-login" onClick={() => window.location.href = "/"}>
                    <Home
                        fontSize="large"
                        sx={{
                            color: "#04642c",
                            fontSize: "3rem",
                            "&:hover": {
                                color: "#034a20",
                                transform: "scale(1.1)",
                                transition: "0.2s",
                            },
                        }}
                    />
                    <span>Voltar ao Login</span>
                </div>
            </form>
        </div>
    );
}
